<template>
    <div style="position: relative;">
        <div class="sticky-progress-indicator">
            <div class="my-constrained-container">
                <span :class="['progress-step', { active: currentStep >= 1 }]">1. {{ __('Rendelés választás') }}</span>
                <span :class="['progress-step', { active: currentStep >= 2 }]">2. {{ __('Termék választás') }}</span>
                <span :class="['progress-step', { active: currentStep >= 3 }]">3. {{ __('Csere adatok') }}</span>
                <span :class="['progress-step', { active: currentStep >= 4 }]">4. {{ __('Összesítés') }}</span>
                <span :class="['progress-step', { active: currentStep >= 5 }]">5. {{ __('Siker') }}</span>
            </div>
        </div>

        <div v-if="errorMessage"
             class="alert alert-danger"
        >
            {{ errorMessage }}
        </div>

        <div v-if="currentStep !== 5" class="loading-container">
            <div class="loading-animation"><div></div><div></div><div></div><div></div></div>
        </div>


        <div class="product-return-container">
            <transition :name="slideMode" mode="out-in">
                <product-return-orders-list
                    v-if="currentStep === 1"
                    class="component-item"
                    :orders="orders"
                    @select-order="selectOrder"
                ></product-return-orders-list>

                <product-return-product-list
                    v-if="currentStep === 2"
                    class="component-item"
                    :selected-order="selectedOrder"
                    @go-back="goBack"
                    @select-items="selectItems"
                ></product-return-product-list>

                <product-return-products
                    v-if="currentStep === 3"
                    class="component-item"
                    :selected-items="selectedItems"
                    :return-reasons="returnReasons"
                    :return-types="returnTypes"
                    :app-url="appUrl"
                    @go-back="goBack"
                    @return-items="returnItems"
                ></product-return-products>

                <product-return-summary
                    v-if="currentStep === 4"
                    class="component-item"
                    :return-reasons="returnReasons"
                    :return-types="returnTypes"
                    :returned-items="returnedItems"
                    :user-account="account"
                    :is-creating="isCreating"
                    @go-back="goBack"
                    @save="createReturnModel"
                ></product-return-summary>

                <div
                    v-if="currentStep === 5"
                    class="component-item"
                >
                    <portal-target
                        v-if="portalAvailable"
                        name="product-return-create-success-header"
                    />

                    <div class="font-bold my-5 text-center">
                        <a :href="downloadUrl"
                           target="_blank"
                           class="btn"
                           style="background: #b7d630;"
                        >
                            <i class="fa fa-cloud-download"></i>
                            {{ __('Letöltés a nyomtatáshoz') }}
                        </a>
                    </div>

                    <portal-target
                        v-if="portalAvailable"
                        name="product-return-create-success-footer"
                    />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductReturn',

    props: {
        orders: {
            type: Object|Array,
            required: true
        },
        returnReasons: {
            type: Object,
            required: true
        },
        returnTypes: {
            type: Object,
            required: true
        },
        saveUrl: {
            type: String,
            required: true
        },
        appUrl: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            currentStep: 1,
            selectedOrder: {},
            selectedItems: [],
            returnedItems: [],
            account: {},
            downloadUrl: null,
            errorMessage: null,
            slideMode: 'slide',
            isCreating: false,
        }
    },

    computed: {
        portalAvailable() {
            return 'PortalTarget' in this.$options.components
        },
    },

    methods: {
        selectOrder(order) {
            this.selectedOrder = order;
            this.currentStep = 2;
            this.scrollTop();
        },

        selectItems(items) {
            this.selectedItems = items;
            this.currentStep = 3;
            this.scrollTop();
        },

        returnItems(items, account) {
            this.returnedItems = items;
            this.account = account;
            this.currentStep = 4;
            this.scrollTop();
        },

        createReturnModel() {
            this.errorMessage = null;
            this.isCreating = true;

            axios.post(this.saveUrl,
                {
                    order: this.selectedOrder.id,
                    items: this.returnedItems,
                    account: this.account
                })
                .then(response => {
                    this.downloadUrl = response.data.downloadUrl
                    this.currentStep = 5;
                    this.scrollTop();
                })
                .catch(error => {
                    this.errorMessage = error.response.data.error || this.__('Hiba történt a feldolgozás közben!');
                    this.isCreating = false;
                });
        },

        goBack() {
            this.currentStep--;
            this.scrollTop(false);
        },

        scrollTop(slideMode = true) {
            this.slideMode = slideMode ? 'slide' : 'slide-reverse';
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
    },
}
</script>

<style lang="scss" scoped>
.product-return-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    overflow: hidden;
}

.component-item {
    width: 100%;
    background: #fff;
}

.slide-enter-active,
.slide-leave-active,
.slide-reverse-enter-active,
.slide-reverse-leave-active {
    transition: transform 0.5s;
}

.slide-enter,
.slide-reverse-leave-to {
    transform: translateX(100%);
}

.slide-leave-to,
.slide-reverse-enter {
    transform: translateX(-100%);
}

.slide-enter-to,
.slide-leave,
.slide-reverse-enter-to,
.slide-reverse-leave {
    transform: translateX(0);
}
</style>
